import request from '@/utils/request';
// 库存台账列表
export const getStock = (params: any) =>
  request({
    url: 'Stock/stock',
    method: 'GET',
    params
  });
export const editorStock = (data: any) =>
  request({
    url: 'Stock/stock',
    method: 'put',
    data
  });
export const addStock = (data: any) =>
  request({
    url: 'Stock/stock',
    method: 'post',
    data
  });
export const delStock = (data: any) =>
  request({
    url: 'Stock/stock',
    method: 'DELETE',
    data
  });
export const addStockModel = (data: any) =>
  request({
    url: 'Stock/stockModel',
    method: 'post',
    data
  });
export const editorStockModel = (data: any) =>
  request({
    url: 'Stock/stockModel',
    method: 'put',
    data
  });
export const delStockModel = (data: any) =>
  request({
    url: 'Stock/stockModel',
    method: 'delete',
    data
  });
  // 导入库存
export const importStock = (data: any) =>
  request({
    url: 'Stock/importStock',
    method: 'post',
    data
  });
  // 到处库存
export const exportStock = (params: any) =>
  request({
    url: 'Stock/exportStock',
    method: 'get',
    params
  });

// 库存设置
// 出入库类型
export const getStockInoutTypeList = (params: any) =>
  request({
    url: 'StockInout/stockInoutTypeList',
    method: 'get',
    params
  });
export const addStockInoutType = (params: any) =>
  request({
    url: 'StockInout/StockInoutType',
    method: 'POST',
    params
  });
export const editorStockInoutType = (params: any) =>
  request({
    url: 'StockInout/StockInoutType',
    method: 'put',
    params
  });
export const delStockInoutType = (params: any) =>
  request({
    url: 'StockInout/StockInoutType',
    method: 'DELETE',
    params
  });
  // 预警人员
export const getStockWarningUserList = (params: any) =>
  request({
    url: 'StockInout/stockWarningUserList',
    method: 'get',
    params
  });
export const addStockWarningUser = (data: any) =>
  request({
    url: 'StockInout/stockWarningUser',
    method: 'post',
    data
  });
  // 个人统计
export const getPersonStatisticsList = (params: any) =>
  request({
    url: 'StockInout/personStatisticsList',
    method: 'get',
    params
  });
export const personStatisticsExport = (params: any) =>
  request({
    url: 'StockInout/personStatisticsExport',
    method: 'get',
    params
  });
export const getCustomerStatisticsList = (params: any) =>
  request({
    url: 'StockInout/customerStatisticsList',
    method: 'get',
    params
  });
export const customerStatisticsExport = (params: any) =>
  request({
    url: 'StockInout/customerStatisticsExport',
    method: 'get',
    params
  });
  // 出入库记录StockInout/record
export const getRecord = (params: any) =>
  request({
    url: 'StockInout/record',
    method: 'get',
    params
  });
export const getRecordDetail = (params: any) =>
  request({
    url: 'StockInout/detail',
    method: 'get',
    params
  });
export const recordExport = (params: any) =>
  request({
    url: 'StockInout/recordExport',
    method: 'get',
    params
  });
// 入库
export const stockIn = (data: any) =>
  request({
    url: 'StockInout/stockIn',
    method: 'POST',
    data
  });
  // 出库
export const stockOut = (data: any) =>
  request({
    url: 'StockInout/stockOut',
    method: 'POST',
    data
  });
  // 批量核销
export const batchChargeOff = (data: any) =>
  request({
    url: 'StockInout/batchChargeOff',
    method: 'POST',
    data
  });
  // 获取核销列表
export const chargeOffList = (params: any) =>
  request({
    url: 'StockInout/chargeOffList',
    method: 'get',
    params
  });
export const getStockCheckList = (params: any) =>
  request({
    url: 'StockCheck/list',
    method: 'get',
    params
  });
  // 添加盘点数量
export const setStockCheckNumber = (data: any) =>
  request({
    url: 'StockCheck/stockCheck',
    method: 'POST',
    data
  });
  // 保存盘点
export const saveStockCheck = (data: any) =>
  request({
    url: 'StockCheck/stockCheck',
    method: 'PUT',
    data
  });
  // 盘点历史记录
export const getStockCheckHistory = (params: any) =>
  request({
    url: 'StockCheck/history',
    method: 'get',
    params
  });
  // 获取盘点时间
export const getStockCheckHistoryTime = (params: any) =>
  request({
    url: 'StockCheck/historyTime',
    method: 'get',
    params
  });
// 盘点历史记录导出
export const stockCheckHistoryExport = (params: any) =>
  request({
    url: 'StockCheck/historyExport',
    method: 'get',
    params
  });
// 获取同步失败记录
export const getSyncPartsFailList = (params: any) =>
  request({
    url: 'StockInout/syncPartsFailList',
    method: 'get',
    params
  });
  // 申领列表
export const getApplyStockInoutList = (params: any) =>
  request({
    url: 'StockInout/applyStockInoutList',
    method: 'get',
    params
  });
// 申领通过
export const editStockApplyInout = (data: any) =>
  request({
    url: 'StockInout/editStockApplyInout',
    method: 'put',
    data
  });
